<template id="map-template">
  <div class="map-root select-none">
    <div ref="map-emap" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="map-header">
      <div class="map-header-wrapper select-none">
        <div class="title">
          <div class="text">{{ this.combineTile }}</div>
          <div class="time">事发时间：{{ this.occurredTimeString }}</div>
          <div class="time">当前时间：{{ this.currentTimeString }}</div>
        </div>
        <div class="btns">
          <div class="btn-position select-none" @click="Communicate">
            <i class="el-icon-phone text"></i>
            融合通讯
          </div>
          <div class="btn-position select-none" @click="goCenter">
            <img
              src="../../../theme-default/src/images/emergencyoperations-header-button-position.png"
            />
            事故位置
          </div>
          <div class="btn-close select-none" @click="closeemergency">
            <img
              src="../../../theme-default/src/images/emergencyoperations-header-button-close.png"
            />
            结束应急
          </div>
        </div>
        <div class="spend-time">
          <span>{{ dateduration.hh }}</span>
          <span>{{ dateduration.hl }}</span>
          <span>:</span>
          <span>{{ dateduration.mh }}</span>
          <span>{{ dateduration.ml }}</span>
          <span>:</span>
          <span>{{ dateduration.sh }}</span>
          <span>{{ dateduration.sl }}</span>
        </div>
      </div>
    </div>
    <div class="map-left">
      <div>
        <ComponentLeftPanel
          v-bind:ExecutId="this.query.ExecutId"
          :roomId="roomId"
          :pwd="pwd"
          :center="center"
          @searchPoi="search"
        ></ComponentLeftPanel>
      </div>
    </div>
    <div class="map-right">
      <div>
        <ComponentRightPanel
          v-bind:ExecutId="this.query.ExecutId"
          v-bind:tableData="executeTaskList"
          v-bind:planName="planName"
          v-bind:planId="planId"
          :roomId="roomId"
          :pwd="pwd"
        ></ComponentRightPanel>
      </div>
    </div>
    <!-- <div class="map-location" @click="handleSwitch2D3D">2D/3D切换</div> -->
    <el-dialog
      class="select-none scroll-no"
      custom-class="emergencyoperations-dialog"
      title="应急预案启动中"
      top="17vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <ComponentTaskList
        v-bind:tableData="executeTaskList"
        v-bind:planName="planName"
      />
    </el-dialog>

    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMaterialStorageVisiable"
    >
      <MaterialWarehouseinfo v-bind:query="materialQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isRescueTeamVisiable"
    >
      <ResourcesTeaminfo v-bind:query="rescueTeamQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isTranresourcesmanageVisiable"
    >
      <Tranresourcesinfo v-bind:query="tranresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isSheltermanageVisiable"
    >
      <Shelterinfo v-bind:query="sheltermanageQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isCommunicationresourcesVisiable"
    >
      <Communicationresourcesinfo v-bind:query="communicationresourcesQuery" />
    </el-dialog>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMedicalResourcesVisiable"
    >
      <Medicalresourcesinfo v-bind:query="medicalResourcesQuery" />
    </el-dialog>

    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isMateriallistVisiable"
    >
      <Materiallist
        v-bind:query="materiallistQuery"
        :WarehouseId="materiallistQuery.obj"
      />
    </el-dialog>
    <el-dialog
      class="select-none scroll-no"
      custom-class="communicate-dialog"
      top="17vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="IsCommunicateVisable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <LinkGroup :groupArray="groupList"></LinkGroup>
    </el-dialog>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

import ComponentLeftPanel from "./Components/Component-LeftPanel";
import ComponentRightPanel from "./Components/Component-RightPanel";
import ComponentTaskList from "./Components/Component-StartTaskList";

import MaterialWarehouseinfo from "../Material/MaterialWarehouseinfo";
import ResourcesTeaminfo from "../Resources/ResourcesTeaminfo";
import Tranresourcesinfo from "../Resources/Tranresourcesinfo";
import Shelterinfo from "../Resources/Shelterinfo";
import Communicationresourcesinfo from "../Resources/Communicationresourcesinfo";
import Medicalresourcesinfo from "../Resources/Medicalresourcesinfo";

import Materiallist from "../Material/Materiallist";

import LinkGroup from "../../../../../TstcIndex/src/views/src/components/LinkGroup";

import WebSocketApi from "../../../../../../websoket/intercomWebsocket";
//import { getLocalIp } from "../../../../../../request/localproxyhttp";

const strNumber = global.$config.api.strNumber;
const strPassword = global.$config.api.strPassword;
const strLocalIP = global.$config.api.strLocalIP;
const strServer = global.$config.api.strServer;

export default {
  name: "ZjEmergencyOperations",
  componentName: "ZjEmergencyOperations",
  components: {
    ComponentLeftPanel: ComponentLeftPanel,
    ComponentRightPanel: ComponentRightPanel,
    ComponentTaskList: ComponentTaskList,

    MaterialWarehouseinfo: MaterialWarehouseinfo,
    ResourcesTeaminfo: ResourcesTeaminfo,
    Tranresourcesinfo: Tranresourcesinfo,
    Shelterinfo: Shelterinfo,
    Communicationresourcesinfo: Communicationresourcesinfo,
    Medicalresourcesinfo: Medicalresourcesinfo,
    Materiallist: Materiallist,
    LinkGroup: LinkGroup,
  },
  props: {
    query: {
      ExecutId: {
        type: String,
        required: true,
        default: "",
      },
    },
    toUrl: {
      type: String,
      default: "/plugin/Emergency/UI/FinishEvent",
    },
  },
  data() {
    return {
      roomId: ZJApp.ZJUtils.uuid(),
      pwd: "123456",
      msgkey: {
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTask" + this.query.ExecutId,
      },
      center: {
        type: Object,
        default: function () {
          return [0, 0];
        },
      },
      loadingText: "加载中...",
      mapInstance: null,
      basicData: {
        title: {
          first: "",
          middle: "火灾应急事件",
          last: "应急指挥中",
        },
        occurredTime: new Date(),
        currentTime: new Date(),
      },
      dateFormat: "yyyy-MM-dd hh:mm:ss",

      isVisiable: false,
      //执行任务列表
      executeTaskList: [],
      planName: "",
      planId: "",
      EventId: "",

      isMaterialStorageVisiable: false,
      materialQuery: {
        type: "search",
        obj: "",
        category: "",
      },
      isRescueTeamVisiable: false,
      rescueTeamQuery: {
        type: "search",
        obj: "",
        category: "",
      },
      isTranresourcesmanageVisiable: false,
      tranresourcesQuery: {
        type: "search",
        obj: "",
        category: "",
      },
      isSheltermanageVisiable: false,
      sheltermanageQuery: {
        type: "search",
        obj: "",
        category: "",
      },
      isCommunicationresourcesVisiable: false,
      communicationresourcesQuery: {
        type: "search",
        obj: "",
        category: "",
      },
      isMedicalResourcesVisiable: false,
      medicalResourcesQuery: {
        type: "search",
        obj: "",
        category: "",
      },

      isMateriallistVisiable: false,
      materiallistQuery: {
        type: "search",
        obj: "",
        category: "",
      },

      IsCommunicateVisable: false,

      LoginSend: {
        strNumber: strNumber,
        strPassword: strPassword,
        strLocalIP: strLocalIP,
        strServer: strServer,
      },
      ws: null,
      InitTimer: "",
      href: "/lib/proxy/LocalproxySetup.zip",
      hrefimg: "/lib/proxy/localproxy.png",
      href2: "/lib/proxy/IPDispatcherProxy_setup.zip",
      href2img: "/lib/proxy/IPDispatcherProxy.png",
      deptArray: [] /*用户部门列表*/,
      userStateArray: [] /*用户状态列表*/,
      //声明一个变量来注册监听事件
      getSocketData: null,
      pttGroupArray: [] /*对讲组列表*/,
      pttGroupMembersArray: [] /*对讲组成员列表*/,
      groupList: [],
      showGroup: [],
    };
  },
  methods: {
    initTime() {
      /*时间处理*/
      this.InitTimer = setInterval(this.InitConnect, 1000);
    },
    InitWebSocket() {
      this.ws = WebSocketApi.OpenWebsoket(this.LoginSend);
    },
    InitConnect() {
      let that = this;
      if (this.TimerCount++ > 5) {
        // this.$alert(
        //   `话机注册超时，请检查调度代理控件是否安装并运行！<br/><img src=${this.href2img} style='width:20px;height:20px'/><a href=${this.href2} type="primary" download="IPDispatcherProxy_setup.zip" style='color:#4194fc'>下载地址</a>`,
        //   "话机注册超时",
        //   {
        //     dangerouslyUseHTMLString: true,
        //   }
        // );
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
        return;
      }

      var ConnectState = WebSocketApi.GetConnectState();
      if (ConnectState == "Success") {
        var LoginState = WebSocketApi.GetLoginState();
        if (LoginState == "Success") {
          that.$message({ type: "success", message: "融合通讯登录成功" });
          this.searchAllSubscribers();
          this.searchGroupData();
          this.searchPttGroupList();
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
        } else if (LoginState == "Fail") {
          //that.$message({ type: "error", message: "话机注册失败" });
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
        }
      } else if (ConnectState == "Fail") {
        this.$alert(
          `对讲机服务器连接失败，请检查调度代理控件是否安装并运行！<br/><img src=${this.href2img} style='width:20px;height:20px'/><a href=${this.href2} type="primary" download="IPDispatcherProxy_setup.zip" style='color:#4194fc'>下载地址</a>`,
          "对讲机服务器连接失败",
          {
            dangerouslyUseHTMLString: true,
          }
        );
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
      }
    },
    searchAllSubscribers() {
      WebSocketApi.SendAllSubscribers();
    },
    searchGroupData() {
      WebSocketApi.SendAllSubscriberGroups();
    },
    searchPttGroupList() {
      WebSocketApi.SendGetPttGroupList();
    },
    OnReqMsg() {
      return WebSocketApi.GetErrorMsg();
    },
    OnReqRunState() {
      return WebSocketApi.GetRunstate();
    },
    OnGetConnectCount() {
      return WebSocketApi.GetConnectCount();
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    goCenter: function () {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    Communicate: function () {
      // eslint-disable-next-line no-undef
      this.IsCommunicateVisable = true;
    },
    //添加应急点
    addDom: function () {
      if (!this.mapInstance) return;
      // eslint-disable-next-line no-undef
      var $div = $("<div></div>");
      $div.append(this.getSvgContent());
      $div.css({
        width: "30rem",
        height: "30rem",
        "margin-left": "-15rem",
        "margin-top": "-15rem",
        position: "absolute",
      });

      var interval = setInterval(() => {
        if (this.mapInstance) {
          let layer = this.mapInstance.getLayerByName("DOM");
          if (layer && layer.addDom) {
            clearInterval(interval);
            layer.addDom(this.center[0], this.center[1], $div[0]);
          }
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 获取应急点html
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    loadExecuteTask: function () {
      return new MyApis.ExecutTaskApi()
        .FindByConditions({ ExecutId: this.query.ExecutId, Validity: 1 })
        .then((r) => {
          r = r.data.Data;
          this.executeTaskList = r;
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //资源点查询方法，过滤地图点位
    search: function (text) {
      var map = this.mapInstance;
      var layers = map.getLayers();

      if (text) {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.filter(function (d) {
              var label = this.getLabel(d) || "";
              return label.indexOf(text) >= 0;
            });
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.clearFilter();
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSearchResultPoiSelected: function (id) {
      console.log("onSearchResultPoiSelected:" + id);
      var overlay,
        layers = this.mapInstance.getLayers();

      for (let index = 0; index < layers.length; index++) {
        var ly = layers[index];
        if (ly.findOverlayById) {
          overlay = ly.findOverlayById(id);
          if (overlay && overlay.length > 0) {
            ly.onClick.apply(overlay[0], [{}]);
            break;
          }
        }
      }
    },
    showRecordDetail(params) {
      switch (params.category) {
        case "MaterialStorage":
          this.isMaterialStorageVisiable = true;
          this.materialQuery.obj = params.obj;
          break;
        case "RescueTeam":
          this.isRescueTeamVisiable = true;
          this.rescueTeamQuery.obj = params.obj;
          break;
        case "Tranresourcesmanage":
          this.isTranresourcesmanageVisiable = true;
          this.tranresourcesQuery.obj = params.obj;
          break;
        case "Sheltermanage":
          this.isSheltermanageVisiable = true;
          this.sheltermanageQuery.obj = params.obj;
          break;
        case "Communicationresources":
          this.isCommunicationresourcesVisiable = true;
          this.communicationresourcesQuery.obj = params.obj;
          break;
        case "MedicalResources":
          this.isMedicalResourcesVisiable = true;
          this.medicalResourcesQuery.obj = params.obj;
          break;
        default:
          console.error("未处理的物资类别 :" + params.category);
          break;
      }
    },
    showinventoryList(params) {
      this.isMateriallistVisiable = true;
      this.materiallistQuery.obj = params.obj;
    },
    //结束应急
    closeemergency() {
      let that = this;

      this.$confirm("即将结束应急, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$router.push({
          path: that.toUrl,
          query: {
            EventId: this.EventId,
            Status: "7",
            ExecutId: this.query.ExecutId,
          },
        });
        that.theme.header.visiable = true;
        that.theme.sidemenu.visiable = true;
        // eslint-disable-next-line no-undef
        $(".zj-app").removeClass("zj-emergencyoperations-map");
      });
    },
    startloading() {
      const loading = this.$loading({
        //tatget: document.querySelector("#zj-component-starttasklist"),
        lock: true,
        fullscreen: false,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.5)",
        customClass: "custom-loading-mask",
      });
      return loading;
    },
    drawMap: function () {
      let that = this;
      // 创建地图，并通过样式让地图填满窗口

      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。

          // eslint-disable-next-line no-undef
          $(that.$refs["map-emap"]).zjumap({
            syscode: "ZJMap",
            key: "EmergencyOneMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              //mapStyle: "styles/darknight.json",
              toggleTool: "tool/TreeToggleX",
              //tilesPath: "",
              //clickToShowLocation: false,
              navigationControl3D: true,
              onMapCreated: function (e) {
                that.mapInstance = e.map;
                that.center = e.map.config.center;
                //that.goCenter();
              },
              // eslint-disable-next-line no-unused-vars
              onLayerRendered: function (e) {},
              // eslint-disable-next-line no-unused-vars
              onGettingLayerData: function (e) {
                // console.log({
                //   funName: "onGettingLayerData",
                //   data: that.center,
                // });
                // eslint-disable-next-line no-undef
                e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
                  Longitude: that.center[0],
                  Latitude: that.center[1],
                });
              },
              //地图开关面板切换事件，切换右侧列表框的tab项
              onToogleSwitchClick: function (e) {
                that.broadcast(
                  "componentPOISearchResult",
                  "onMapToogleSwitchClick",
                  e.type
                );
              },
              onLayerDetaiButtonClick: function (e) {
                console.log(e);
                var item = e.originEvent.currentTarget;
                // eslint-disable-next-line no-undef
                var id = $(item).data("id");
                // eslint-disable-next-line no-undef
                var category = $(item).data("category");
                var result = {
                  obj: id,
                  type: "search",
                  category: category,
                };
                that.showRecordDetail(result);
              },
            },
            //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
          });
        });
      });
    },
    loadEventInfo() {
      if (!this.query.ExecutId) {
        this.errmsg("执行记录Id【ExecutId】不能为空");
        return false;
      }

      let that = this;

      const loading = this.startloading();

      //获取执行记录信息
      new MyApis.ExecutRecordApi()
        .GetItemById({ ExecutId: this.query.ExecutId })
        .then((r) => {
          r = r.data.Data;
          // 获取执行记录信息，加载预案名称、触发任务启动弹窗
          that.planName = r.PlanName;
          that.planId = r.PlanId;
          that.basicData.title.middle = r.EventName;
          that.isVisiable = true;
          that.EventId = r.EventId;

          //继续获取应急事件信息
          new MyApis.EmergencyEventApi()
            .GetItemById({ EventId: r.EventId })
            .then((q) => {
              q = q.data.Data;
              //设置事件中心点,事发事件
              that.center = [q.Longitude, q.Latitude];
              console.log(q.Longitude, q.Latitude);
              try {
                that.basicData.occurredTime = new Date(Date.parse(q.EventDate));
              } catch (e) {
                console.error(e);
                that.basicData.occurredTime = new Date();
              }
              // 创建定时器
              that.timer = setInterval(function () {
                that.basicData.currentTime = new Date();
              }, 1000);
            })
            .catch((e) => {
              loading.close();
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            });

          loading.close();
        })
        .catch((e) => {
          loading.close();
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // eslint-disable-next-line no-unused-vars
    onEmergencyFinishTaskKey: function (msg) {
      var record = JSON.parse(msg.firstBlock().text);

      if (
        this.executeTaskList.some(function (item) {
          return item.ExecutTaskId == record.ExecutTaskId;
        })
      ) {
        var result = [];
        // eslint-disable-next-line no-undef
        $.each(this.executeTaskList, function () {
          var item = this;
          if (item.ExecutTaskId == record.ExecutTaskId) {
            // eslint-disable-next-line no-undef
            item = $.extend({}, item, record);
          }
          result.push(item);
        });

        this.executeTaskList = result;
      } else {
        this.executeTaskList.unshift(record);
      }
    },
    onJoinRoomRequestReceived: function (args) {
      //广播消息给子组件
      this.broadcast(
        "ZJEmergencyRealtimecall",
        "onJoinRoomRequestReceived",
        args
      );
    },
    handleSwitch2D3D: function () {
      console.log("handleSwitch2D3D");
      if (this.mapInstance.map.getTilt() == 0) {
        this.mapInstance.map.setTilt(60);
      } else {
        this.mapInstance.map.setTilt(0);
      }
    },
    getSocketMessage() {
      // 创建接收消息函数
      this.getSocketData = (e) => {
        let msgdat = e && e.detail.data;
        //这边编写处理服务端消息代码
        if (msgdat) {
          /*获取所有用户组*/
          if (msgdat.indexOf("SubscriberGroups") != -1) {
            console.log("获取所有用户组成功");
            var myobj = JSON.parse(msgdat);
            const subscriberGroupsArray = myobj.SubscriberGroups;
            this.deptArray = [];
            for (var i = 0; i < subscriberGroupsArray.length; i++) {
              var strText = "";
              var obj = subscriberGroupsArray[i];
              var dept = {};
              dept.GroupName = obj.GroupName;
              dept.GroupMembers = obj.GroupMembers;
              dept.ParentGroup = "";
              this.deptArray.push(dept);
              this.getChildGroups(obj);
              this.GetGroupData();
            }
          }
          /*获取所有对讲组*/
          if (msgdat.indexOf("GetPttGroupList") != -1) {
            //console.log("获取所有对讲组成功");
            var myobj = JSON.parse(msgdat);
            this.pttGroupArray = myobj.GetPttGroupList;
            this.GetPttGroup();
          }
          /*获取某个对讲组的成员*/
          if (msgdat.indexOf("GetPttGroupMembersList") != -1) {
            //console.log("获取某个对讲组的成员");
            var myobj = JSON.parse(msgdat);
            this.pttGroupMembersArray = myobj.GetPttGroupMembersList;
            this.GetPttGroupMembersList();
          }
          var arrInfo = msgdat.split(":");

          if (arrInfo.length == 2) {
            if (arrInfo[0] == "OnErrorMessage") {
              this.getErrInfo(arrInfo[1]);
            }
          }
        }
      };
      //注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
      setTimeout(() => {
        let statusName = WebSocketApi.GetErrorMsg();
        if (statusName) {
          this.$message({
            type: "error",
            message: statusName,
          });
        }
      }, 200);
    },
    getErrInfo(status) {
      let statusName = WebSocketApi.GetErrcodeString(status);
      if (statusName) {
        this.$message({
          type: "error",
          message: statusName,
        });
      }
    },
    GetGroupData() {
      /*获取用户组*/
      let that = this;
      // if (this.GroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对用户组信息超时" });
      //   this.GroupTimerCount = 0;
      //   //console.log("获取对用户组信息超时");
      //   clearInterval(this.GroupDataTimer);
      //   return;
      // }
      // let subscribersgroupsArray = WebSocketApi.GetAllSubscriberGroups();
      let subscribersgroupsArray = this.deptArray;
      if (
        subscribersgroupsArray != undefined &&
        subscribersgroupsArray.length > 0
      ) {
        this.showGroup = [];
        subscribersgroupsArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.GroupName,
            name: item.GroupName,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          var members = item.GroupMembers.split(",");
          if (members != undefined && members.length > 0) {
            members.forEach((mitem) => {
              let childitem = {
                name: WebSocketApi.GetUserNameByNum(mitem),
                id: mitem,
                isChecked: false,
              };
              GroupItem.children.push(childitem);
            });
          }
          this.showGroup.push(GroupItem);
        });
        /*console.log("showGroup",this.showGroup);*/
        this.groupList = this.showGroup;
        this.GroupTimerCount = 0;
        // clearInterval(this.GroupDataTimer);
      }
      this.groupList = this.showGroup;
    },
    GetPttGroup() {
      /*获取对讲组*/
      let that = this;
      // if (this.GetPttGroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对讲机组信息超时" });
      //   //console.log("获取对讲机组信息超时");
      //   this.GetPttGroupTimerCount = 0;
      //   clearInterval(this.GetPttGroupTimer);
      //   return;
      // }
      //let PttGroupArray = WebSocketApi.GetPttGroupList();
      if (this.PttGroupArray != undefined && this.PttGroupArray.length > 0) {
        /*console.log("PttGroupArray",PttGroupArray);*/
        this.PttGroupArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.Number,
            name: item.Name,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          this.showGroup.push(GroupItem);
          //console.log("对讲机通讯", "获取所有对讲组成员" + item.Number);
          WebSocketApi.SendGetPttGroupMembersList(item.Number);
          // this.GetPttGroupMembersListTimer = setInterval(
          //   this.GetPttGroupMembersList,
          //   5000
          // );
          /*获取某个对讲组的成员*/
        });
        // this.GetPttGroupTimerCount = 0;
        // clearInterval(this.GetPttGroupTimer);
      }
    },
    GetPttGroupMembersList() {
      let that = this;
      // if (this.GetPttGroupMembersListTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取某个对讲组的成员超时" });
      //   this.GetPttGroupMembersListTimerCount = 0;
      //   clearInterval(this.GetPttGroupMembersListTimer);
      //   return;
      // }
      //let pttGroupMembers = WebSocketApi.GetPttGroupMembersList();
      if (this.pttGroupMembersArray != undefined) {
        this.showGroup.forEach((item) => {
          if (item.id == this.pttGroupMembersArray.PttGroupNumber) {
            var members = this.pttGroupMembersArray.Members.split(",");
            if (members != undefined && members.length > 0) {
              members.forEach((mitem) => {
                let childitem = {
                  name: WebSocketApi.GetUserNameByNum(mitem),
                  id: mitem,
                  isChecked: false,
                };
                item.children.push(childitem);
              });
            }
          }
        });
        /*console.log("pttGroupMembers",pttGroupMembers);*/
        // this.GetPttGroupMembersListTimerCount = 0;
        // clearInterval(this.GetPttGroupMembersListTimer);
      }
    },
    /*/获取用户组下的子组*/
    getChildGroups(parentGrp) {
      var childs = parentGrp.GroupChilds;
      if (typeof childs != "undefined") {
        for (var i = 0; i < childs.length; i++) {
          var obj = childs[i];
          var dept = {};
          dept.GroupName = obj.GroupName;
          dept.GroupMembers = obj.GroupMembers;
          dept.ParentGroup = parentGrp.GroupName;
          this.deptArray.push(dept);

          this.getChildGroups(obj);
        }
      }
    },
  },
  //初始化，隐藏菜单
  created() {
    this.theme.header.visiable = false;
    this.theme.sidemenu.visiable = false;

    this.$notify.subscript(this.msgkey.emergencyFinishTaskKey, (x) =>
      this.onEmergencyFinishTaskKey(x)
    );

    this.$on("showRecordDetail", this.showRecordDetail);
    this.$on("showinventoryList", this.showinventoryList);
    this.$on("poiselected", this.onSearchResultPoiSelected);
    this.$on("onJoinRoomRequestReceived", this.onJoinRoomRequestReceived);
  },
  mounted() {
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-emergencyoperations-map");
    //加载事件信息
    this.loadEventInfo();
    //绘制地图
    this.drawMap();

    //加载执行任务
    this.loadExecuteTask();

    this.logInfo.ActionName = "进入应急作战指挥";
    this.logInfo.LogMessage = "应急作战指挥查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "应急作战指挥页面";
    this.addOperationLog();
    this.InitWebSocket();
    this.initTime();
    this.getSocketMessage();

    // getLocalIp()
    //   .then((r) => {
    //     if (r.State == 0) {
    //       console.log("获取本地ip", r);
    //       this.LoginSend.strLocalIP = r.ip; //"192.168.43.141"
    //       /*r.ip;*/
    //       console.log("LoginSend", this.LoginSend);
    //       this.InitWebSocket();
    //       this.initTime();
    //     } else {
    //       this.$alert(
    //         `本地代理异常，请检查本地代理是否安装并运行！<br/><img src=${this.hrefimg} style='width:20px;height:20px'/><a href=${this.href} type="primary" download="LocalproxySetup.zip" style='color:#4194fc'>下载地址</a>`,
    //         "本地代理异常",
    //         {
    //           dangerouslyUseHTMLString: true,
    //         }
    //       );
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     this.$alert(
    //       `本地代理异常，请检查本地代理是否安装并运行！<br/><img src=${this.hrefimg} style='width:20px;height:20px'/><a href=${this.href} type="primary" download="LocalproxySetup.zip" style='color:#4194fc'>下载地址</a>`,
    //       "本地代理异常",
    //       {
    //         dangerouslyUseHTMLString: true,
    //       }
    //     );
    //   });
  },
  computed: {
    combineTile: function () {
      return (
        this.basicData.title.first +
        this.basicData.title.middle +
        this.basicData.title.last
      );
    },
    occurredTimeString: function () {
      return this.basicData.occurredTime.format(this.dateFormat);
    },
    currentTimeString: function () {
      return this.basicData.currentTime.format(this.dateFormat);
    },
    dateduration: function () {
      var diff =
        this.basicData.currentTime.getTime() -
        this.basicData.occurredTime.getTime();
      //计算出小时数
      var hours = Math.floor(diff / (3600 * 1000));
      //计算相差分钟数
      var left = diff % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(left / (60 * 1000));
      //计算相差秒数
      left = left % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(left / 1000);

      return {
        hours: hours,
        hh: parseInt(hours / 10) % 10,
        hl: hours % 10,
        minutes: minutes,
        mh: parseInt(minutes / 10),
        ml: minutes % 10,
        seconds: seconds,
        sh: parseInt(seconds / 10),
        sl: seconds % 10,
      };
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
    }
  },
  destroyed() {
    this.$notify.unsubscript(this.msgkey.emergencyFinishTaskKey);
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    $(".zj-app").removeClass("zj-emergencyoperations-map");
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
  },
  watch: {
    //监听中心点，绘制应急中心点
    center: function () {
      let that = this;
      var interval = setInterval(() => {
        if (that.mapInstance) {
          clearInterval(interval);
          this.addDom();
        }
      }, 1000);
    },
  },
  template: "#map-template",
  controller: "UI",
  action: "EmergencyOperations",
};
</script>
